import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import KioskPage from './kiosk/KioskPage';
import AdminPage from './admin/AdminPage';
import DonatePage from './donate/DonatePage';
import SuccessPage from './donate/SuccessPage';
import CancelPage from './donate/CancelPage';
import PrintPage from './print/PrintPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<KioskPage />} />
      <Route path="/admin/*" element={<AdminPage />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/donate/success" element={<SuccessPage />} />
      <Route path="/donate/cancel" element={<CancelPage />} />
      <Route path="/print" element={<PrintPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
